import * as React from 'react';

import { ServicesPricingPageLocale } from './servicesPricingPage.locale';
import Ixp from './Ixp/Ixp';
import Schema from './Schema/Schema';
import Header from '../Header/Header';
import SectionTitle from '../SectionTitle/SectionTitle';
import Cta from '../Cta/Cta';
import Blob from '../Blob/Blob';

import headerBg from './headerBg.svg';
import List from '../List/List';
import LinkButton from '../Button/LinkButton';
import { Language } from '../../containers/Localization/localizationDuck';

interface ServicesPricingPageProps {
  locale: ServicesPricingPageLocale;
  language: Language;
}

const ServicesPricingPage: React.SFC<ServicesPricingPageProps> = ({ locale, language }) => (
  <>
    <Header
      title={locale.header.title}
      subtitle={locale.header.subtitle}
      backgroundImage={headerBg}
      backgroundSize="auto 150%"
      backgroundPosition="70% 50%"
    />
    <main>
      <section className="container py-7 py-md-8">
        <SectionTitle>{locale.standardServices.title}</SectionTitle>
        <Ixp locale={locale.standardServices.ixp} />

        <div className="row align-items-center justify-content-center justify-content-md-start my-6 my-md-7">
          <div className="col-12 col-md-7 col-lg-6">
            <h4 className="mb-3 font-weight-bold">
              {locale.standardServices.customerPortal.title}
            </h4>
            <p className="mb-4">{locale.standardServices.customerPortal.description}</p>
            <List
              items={locale.standardServices.customerPortal.featuresList.map((feature, index) => (
                <span key={index} dangerouslySetInnerHTML={{ __html: feature }} />
              ))}
            />
          </div>
          <div className="col-10 col-sm-8 col-md-5 col-lg-4 offset-lg-1 mt-5 mt-md-0">
            <Schema locale={locale.standardServices.schema} />
          </div>
        </div>

        <SectionTitle>{locale.additionalServices.title}</SectionTitle>
        <div className="row mt-md-3">
          {locale.additionalServices.servicesList.map(service => (
            <div key={service.title} className="col-12 col-md-6 mt-5">
              <h4 className="mb-3 font-weight-bold">{service.title}</h4>
              <p dangerouslySetInnerHTML={{ __html: service.description }} />
            </div>
          ))}
        </div>
      </section>
      <div className="position-relative d-none d-lg-block">
        <Blob bottom="140px" />
      </div>
      <Cta title={locale.cta.title} backgroundType="circles">
        <div className="row justify-content-center">
          <div className="col-auto mb-3 mb-sm-0">
            <LinkButton to={locale.cta.primaryButton.href}>
              {locale.cta.primaryButton.text}
            </LinkButton>
          </div>
          <div className="col-auto">
            <LinkButton to={locale.cta.secondaryButton.href} secondary>
              {locale.cta.secondaryButton.text}
            </LinkButton>
          </div>
        </div>
      </Cta>
    </main>
  </>
);

export default ServicesPricingPage;



// WEBPACK FOOTER //
// /www/client/src/components/ServicesPricingPage/ServicesPricingPage.tsx